import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import dayjs from 'dayjs';
import {MdLogin} from "react-icons/md";
import './projectShell.css';


import {Affix, Drawer} from "antd";
import {
    Table,
    Select,
    Button,
    ConfigProvider,
    Modal,
    Form,
    Input,
    Card,
    Space,
    message,
    FloatButton,
    Popconfirm, Alert, Cascader, Divider, Radio, Checkbox, Watermark, Tabs, TabPaneProps, TabsProps, Collapse, Calendar
} from 'antd';

import {FileAddOutlined, UserSwitchOutlined} from '@ant-design/icons'
import type {MenuProps} from 'antd';

import {Breadcrumb, Layout, Menu, theme} from 'antd';

import {LaptopOutlined, NotificationOutlined, UserOutlined} from '@ant-design/icons';
import {Outlet, Link, Navigate, Route, Routes, useLocation} from "react-router-dom";


import {useNavigate} from 'react-router-dom';
import Column from 'antd/lib/table/Column';
import {ColumnsType} from "antd/es/table";

import copy from 'copy-to-clipboard';
import Search from "antd/es/input/Search";

import cookies from "js-cookie";



const {Header, Content, Footer, Sider} = Layout;

const {Option} = Select;


let access_in = "jj";


function Ddjj() {
    const na1vigate = useNavigate();

    na1vigate("/projectlogin")

}


const items2: MenuProps['items'] = [




    {key: '/project/projectmanagement', label: <Link to="/project/projectmanagement">项目管理</Link>},
    {key: '/project/vipcard', label: <Link to="/project/vipcard">vipcard</Link>},
    {key: '/project/downloadmanagement', label: <Link to="/project/downloadmanagement">下载管理</Link>},
    {key: '/project/setting', label: <Link to="/project/setting">设置</Link>},


]


const Project_Index_UI = () => {
    document.title = '后台管理';


    let location = useLocation();



    const [re_cookie, setre_cookie] = useState({message: '', time: 0})

    const navigate = useNavigate();





    useEffect(() => {
        const usecookie = () => {


            if (Cookies.get('group') !== 'projectadmin') {

                message.error('无访问权限')
                navigate('/projectlogin?return_url=/project')


            } else {


                switch (Cookies.get('userToken_chattool')) {

                    case undefined:

                        navigate('/projectlogin?return_url=/project')


                        break;

                    default:



                        let data_time = dayjs().unix();



                        break;


                }

            }
        }

        usecookie();
    }, []); // 空数组表示仅在组件挂载时执行




    const Admin_log_out = () => {


        Cookies.remove('userToken_chattool')

        Cookies.remove('group')



        let time = dayjs().unix();
        navigate('/projectlogin')

        return (
            console.log("111")

        );


    }





    const [get_setting_info_select_log,setget_setting_info_select_log]=useState({message:'',value:'',time:0})


    let data_time=dayjs().unix();

    //首次运行
    useEffect(() => {


        setget_usermessage_select_log({message: '首次运行',  value: '',time: data_time})

        setget_setting_info_select_log({message: '首次运行', value: '', time: data_time})

    }, []);







    const [use_message_return, setuser_message_requset_returen] = useState({user_oname: '', group_name: ''});
    const post_data_usermess = new FormData();
    post_data_usermess.append('user_token', String(Cookies.get('userToken_chattool')));


    const [get_usermessage_select_log, setget_usermessage_select_log] = useState({message: '', time: 2, value: ''})


    useEffect(() => {


        const user_message = async () => {

            const use_message_await = await fetch('https://api.chatv2.leytcn.com/function_api/myinfo/usermessage.php', {


                method: 'POST',
                body: post_data_usermess
            });

            const data_mee = await use_message_await.json();

            setuser_message_requset_returen(data_mee);




        }

        if (get_usermessage_select_log.message !== '') {


            user_message();
            setget_usermessage_select_log({message:'',value:'',time:0})

            console.log(use_message_return);


        } else {


        }


    }, [get_usermessage_select_log]);


    const [select_menu, setSelect_menu] = useState<string>('item1');



    const [return_setting_fetch_fetch_data,setreturn_setting_fetch_fetch_data]=useState({message:'',info:{id:'',title:'',value1:'',value2:'',value3:'',value4:'',value5:''}})

    const setting_fetch_fetch_data_body=new FormData();
    setting_fetch_fetch_data_body.append('userToken_chattool', String(Cookies.get('userToken_chattool')));

    setting_fetch_fetch_data_body.append('time', String(get_setting_info_select_log.time));

    setting_fetch_fetch_data_body.append('action', 'bease_setting');






    const menu_onclick: MenuProps['onClick'] = (e) => {

        setSelect_menu(e.key)

        console.log(e)


    }

    const {
        token: {colorBgContainer},
    } = theme.useToken();


    const [menu_click_value, setmenu_click_value] = useState({key: '', keyPath: []})
    const menu_click = (e: any) => {

        console.log('menu_onchange_msg, e')

        setmenu_click_value(e)


    }


    return (


        <ConfigProvider theme={{components: {Menu: {
            itemMarginInline: 8,
            itemBorderRadius: 8,
            itemHeight: 44,
            iconSize: 18,
            itemSelectedBg: 'rgba(124, 58, 237, 0.12)',
            itemSelectedColor: '#7c3aed',
            itemHoverBg: 'rgba(0, 0, 0, 0.04)',
            itemActiveBg: 'rgba(124, 58, 237, 0.08)',
            itemColor: 'rgba(0, 0, 0, 0.45)',
        }}}}>
        <Layout className="project-shell-root" style={{minWidth:1000, background: '#f5f5f5'}}>


            <Affix offsetTop={0}>
                <Header style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    background: "#FFFFFF",
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    zIndex: 1000, // Ensure Header is on top
                    minWidth:1000
                }}>

                    <h3 style={{ color: "#000000", margin: 0 }}>后台管理</h3>

                    <div style={{ flexGrow: 1, textAlign: 'right' }}>
                        <MdLogin size={'1.5em'} style={{ marginLeft: 300 }} onClick={Admin_log_out}>
                            退出登录
                        </MdLogin>
                    </div>
                </Header>
            </Affix>

            <Sider
                style={{
                    height: 'calc(100vh - 50px)', // Adjust height to account for Header
                    position: 'fixed',
                    top: 64, // Align below Header
                    left: 0,
                    bottom: 0,
                    backgroundColor: '#fff',
                    borderRight: '1px solid #f0f0f0',
                    width: 200, // Fixed width for Sider
                    zIndex: 900, // Ensure Sider is below Header
                }}
            >

                <Menu
                    theme="light"
                    style={{height: '100%', background: 'transparent', borderInlineEnd: 0, paddingTop: 8}}
                    items={items2}
                    defaultSelectedKeys={[
                        location.pathname === '/project' || location.pathname === '/project/' ? '/project/projectmanagement' : location.pathname
                    ]}
                    onClick={menu_click}
                />
            </Sider>

            <Layout className="project-shell-body" style={{marginLeft: 200}}>

                <Watermark className="project-shell-watermark" inherit content={use_message_return.user_oname}>

                    <Content className="project-shell-content">
                        <div className="project-shell-page"><Outlet /></div>

                    </Content>
                </Watermark>

            </Layout>




        </Layout>
        </ConfigProvider>

    );
}



export default Project_Index_UI;
